export type VestingMilestone = {
  id: string;
  targetDate: Date;
  completionDate: Date;
  milestoneName: string;
  milestoneStatus: MilestoneStatus;
  newlyAdded?: boolean;
  targetDateType?: MilestoneDateType;
  vestingOffset?: number;
  offsetType?: MilestoneOffsetType;
};

export type AddVestingMilestoneReq = {
  id?: string;
  milestoneName: string;
  closureType?: ClosureType;
  milestoneType?: MilestoneType;
  targetDate?: Date;
  completionDate?: Date | undefined;
  vestingOffset?: number;
  offsetType?: MilestoneOffsetType;
  targetDateType?: MilestoneDateType;
  notes?: string;
  companyId?: string;
};

export type VestingMilestoneTableDetails = {
  id: string;
  milestoneName: string;
  targetDate?: Date;
  completionDate?: Date;
  employeesLinked: number;
  employeesCompleted: number;
  employeesPending: number;
  vestingOffset?: number;
  offsetType?: MilestoneOffsetType;
  totalNoOfOptions: number;
  totalNoOfOptionsVested: number;
  totalNoOfOptionsLapsed: number;
  milestoneStatus: MilestoneStatus;
  closureType: ClosureType;
  milestoneType: MilestoneType;
  employeeNames: string[];
};

export enum MilestoneType {
  CompanyWide = "CompanyWide",
  Individual = "Individual",
}

export enum ClosureType {
  Manual = "Manual",
}

export enum MilestoneStatus {
  DRAFT = "DRAFT",
  OPEN = "OPEN",
  FOR_APPROVAL = "FOR_APPROVAL",
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}

export enum MilestoneDateType {
  Absolute = "Absolute",
  Relative = "Relative",
}

export enum MilestoneOffsetType {
  DAYS = "DAYS",
  MONTHS = "MONTHS",
  YEARS = "YEARS",
}

export type VestingMilestoneCompleteDetailsDto = {
  grantId: string;
  milestoneDetails: VestingMilestoneCompleteDetails[];
};

export interface VestingMilestoneCompleteDetails {
  employeeName: string;
  employeeId: string;
  grantId: string;
  grantIdentifier: string;
  optionsGranted: number;
  optionsVested?: number;
  vestedPercentage?: number;
  dateOfVesting?: Date;
  transactionDate?: Date;
  completionDate?: Date;
  notes?: string;
  updateState: VestingMilestoneState;
  milestoneId: string;
  projectedVestingId: string;
  projectedVestingState: VestState;
  isFractional: boolean;
  milestoneName: string;
  targetDate: Date;
  uiVestedPercentage?: number;
  dateOfGrant?: Date;
}

export enum VestingMilestoneState {
  DONOTHING = "-",
  LAPSE = "Lapse",
  EXTEND = "Extend",
}

export enum VestState {
  ACTIVE = "ACTIVE",
  VESTED = "VESTED",
  LAPSED = "LAPSED",
  ACCELERATED = "ACCELERATED",
}

export type MilestoneViewDetail = {
  projectedVestingId: string;
  grantId: string;
  grantIdentifier: string;
  employeeName: string;
  employeeId: string;
  optionsGranted: number;
  vestingDate: Date;
  vestingState: VestState;
  completionDate: Date | null;
  isFractional: boolean;
  dateOfGrant: Date;
};

export type MilestoneViewResponse = {
  id: string;
  milestoneName: string;
  milestoneStatus: MilestoneStatus;
  targetDate: Date | null;
  completionDate: Date | null;
  vestingOffset: number | null;
  offsetType: MilestoneOffsetType | null;
  milestoneType: MilestoneType;
  closureType: ClosureType;
  rows: MilestoneViewDetail[];
};
